export function Header() {
  return (
    <header className="h-16 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-20 w-full flex items-center justify-end px-6 gap-4">
      {/* 移除通知和账号信息，已移至侧边栏 */}
    </header>
  );
}

